import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { MEETING_MONTHLY_FEES_LIST, MEETING_MONTHLY_FEES_STATUS_UPDATE, MEETING_FEES_REGISTRY_STATUS_UPDATE, USER_LIST_DROPDOWN, COUNTRY_LIST_DROPDOWN, STATE_LIST_DROPDOWN, CHAPTER_LIST_DROPDOWN, REGION_LIST_DROPDOWN } from "../../routes/routes";
import { PAGINATE } from "../../constant/constant";
import { toast } from "react-toastify";
import { NoDataFound, Pagination, hasRole } from "../../components/Utils";
import { usePermission } from "../../hooks/usePermission";
import Loader from '../../components/common/Loader'; // Import the loader component
import StickyTable from "../../components/common/StickyTable";
import Form from 'react-bootstrap/Form';
import Select from "react-select";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";
import { MdCancel,MdCheckCircle } from "react-icons/md";


const MonthlyFeesList = () => {
  const { hasPermission } = usePermission();
  // ## State Variable Declaration
  const [data, setData] = useState([]);
  const [paginator, setPaginator] = useState({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [countryOptions, setCountryOptions] = useState({});
  const [stateOptions, setStateOptions] = useState({});
  const [regionOptions, setRegionOptions] = useState({});
  const [chapterOptions, setChapterOptions] = useState({});
  const [filter, setFilter] = useState([]);
  const applyFilter = (next) => {
    setPage(1);
    setFilter(next);
  };
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false); // New state to trigger refresh
  const [userOptions, setUserOptions] = useState({});
  const [showClearBtn, setShowClearBtn] = useState(false);
  const [viewWeeksModal, setViewWeeksModal] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [errors, setErrors] = useState({});
  const [confirmation, setConfirmation] = useState({});
  const [confirmationModal, setConfirmationModal] = useState(false);

  const datePickerRef = useRef(null);
  const selectStateRef = useRef(null);
  const selectRegionRef = useRef(null);
  const selectChapterRef = useRef(null);
  const selectMemberRef = useRef(null);

  const handleStateClear = () => {
    if (selectStateRef.current) selectStateRef.current.clearValue();
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
    if (selectMemberRef.current) selectMemberRef.current.clearValue();
  };

  const handleRegionClear = () => {
    if (selectRegionRef.current) selectRegionRef.current.clearValue();
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
    if (selectMemberRef.current) selectMemberRef.current.clearValue();
  };

  const handleChapterClear = () => {
    if (selectChapterRef.current) selectChapterRef.current.clearValue();
    if (selectMemberRef.current) selectMemberRef.current.clearValue();
  };

  const handleMemberClear = () => {
    if (selectMemberRef.current) selectMemberRef.current.clearValue();
  };

  const auth_user = JSON.parse(localStorage.getItem("user"));
  const isSuperAdmin = auth_user?.user_type === 1 ? 1 : 0;
  const isRegionAdmin = auth_user?.user_type === 2 ? 1 : 0;
  const isChapterAdmin = auth_user?.user_type === 3 ? 1 : 0;
  const currentUpdatedByName = isSuperAdmin === 1 ? "Admin" : (auth_user?.name || "Admin");

  const statusOptions = [
    { value: 0, label: "Pending" },
    { value: 2, label: "Partially Paid" },
    { value: 1, label: "Paid" },
  ];

  const handleDateRangeClear = () => {
    setShowClearBtn(false);
    applyFilter({
      ...filter,
      month_date: "",
    })
  };

  const updatePaymentStatus = (meetingId, status) => {
    axios
      .post(MEETING_MONTHLY_FEES_STATUS_UPDATE + meetingId, { status: status })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          toast.success(response.data.msg);
          setRefresh((prevRefresh) => !prevRefresh);
          if (selectedSchedule?.id === meetingId) {
            setSelectedSchedule((prev) => ({
              ...prev,
              payment_status: status,
              meeting_weeks: prev?.meeting_weeks?.map((w) => ({
                ...w,
                paid: status === 1,
                paid_at: status === 1 ? (w.paid_at || moment().format("DD-MM-YYYY hh:mm A")) : null,
                updated_by_name: status === 1 ? (w.updated_by_name || currentUpdatedByName) : null,
              })),
            }));
          }
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.msg || "Failed to update payment status.");
      });
  };

  const updateWeeklyPaymentStatus = (weeklyFeeId, status, idx, isChecked, currentPaidAt) => {
    if (!weeklyFeeId) return;
    axios
      .post(MEETING_FEES_REGISTRY_STATUS_UPDATE + weeklyFeeId, { status: status })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          toast.success(response.data.msg);
          setRefresh((prevRefresh) => !prevRefresh);
          setSelectedSchedule((prev) => {
            const updatedWeeks = [...(prev?.meeting_weeks || [])];
            if (updatedWeeks[idx]) {
              updatedWeeks[idx] = {
                ...updatedWeeks[idx],
                paid: isChecked,
                paid_at: currentPaidAt,
                updated_by_name: isChecked ? currentUpdatedByName : null,
              };
            }
            const allPaid = updatedWeeks.every((w) => w.paid);
            const anyPaid = updatedWeeks.some((w) => w.paid);
            const newStatus = allPaid ? 1 : anyPaid ? 2 : 0;
            return {
              ...prev,
              payment_status: newStatus,
              meeting_weeks: updatedWeeks,
            };
          });
        }
      })
      .catch((err) => {
        toast.error(err.response?.data?.msg || "Failed to update payment status.");
      });
  };


  useEffect(() => {
    setLoading(true);
    axios
      .get(MEETING_MONTHLY_FEES_LIST, {
        params: {
          type: PAGINATE,
          page: page,
          perPage: perPage,
          isAdmin: 1,
          ...filter
        }
      })
      .then((response) => {
        if (
          response.status === 200 &&
          response.data.success
        ) {
          setData(response.data.data.schedules);
          setSelectedSchedule((prevSelected) => {
            if (!prevSelected) return null;
            const updated = response.data.data.schedules.find(
              (item) => item.id === prevSelected.id
            );
            return updated || prevSelected;
          });
          setPaginator({
            prev: response.data.data.prev_page_url != null,
            next: response.data.data.next_page_url != null,
            total: response.data.data.total,
            current: response.data.data.current_page,
            last: response.data.data.last_page,
          });
        }
      }).finally(() => {
        setLoading(false); // Set loading to false after data is fetched
      });


    const fetchData = async () => {
      try {
        // Fetch user data
        const region_id = (isRegionAdmin === 1) ? auth_user?.region_id : "";
        const chapter_id = (isChapterAdmin === 1) ? auth_user?.chapter_id : "";

        const userResponse = await axios.get(USER_LIST_DROPDOWN, {
          params: {
            ...filter,
            exclude_other_region_chapter_users: 1,
          }
        });
        const fetchedUserOptions = userResponse.data.data;
        setUserOptions(fetchedUserOptions);

        // Fetch country data
        const countryResponse = await axios.get(COUNTRY_LIST_DROPDOWN);
        const fetchedCountryOptions = countryResponse.data.data;
        setCountryOptions(fetchedCountryOptions);

        // Fetch state data
        const stateResponse = await axios.get(STATE_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedStateOptions = stateResponse.data.data;
        setStateOptions(fetchedStateOptions);

        // Fetch region data
        const regionResponse = await axios.get(REGION_LIST_DROPDOWN, {
          params: {
            ...filter,
          },
        });
        const fetchedRegionOptions = regionResponse.data.data;
        setRegionOptions(fetchedRegionOptions);

        // Fetch chapter data
        const chapterResponse = await axios.get(CHAPTER_LIST_DROPDOWN, {
          params: {
            ...filter
          }
        });
        const fetchedChapterOptions = chapterResponse.data.data;
        setChapterOptions(fetchedChapterOptions);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();

  }, [page, refresh, perPage, filter]);

  const handleCalendarClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const renderMeetingWeeks = (meetingWeeks = []) => {
    if (!meetingWeeks.length) {
      return "-";
    }

    return (
      <div className="meeting-weeks-track">
        {meetingWeeks.map((week, index) => {
          const weekLabel = week?.paid ? "paid" : "pending";
          const tooltipText = `Week ${index + 1} ${weekLabel} (${week?.meeting_date})`;

          return (
            <OverlayTrigger
              key={index}
              placement="top"
              overlay={<Tooltip id={`meeting-week-tooltip-${index}`}>{tooltipText}</Tooltip>}
            >
              <span
                className="badge bg-label-success1 border-0 pad-4 meeting-week-badge"
              >
                {week?.paid ? (
                  <MdCheckCircle  className="bx bx-check-circle meeting-week-badge-icon is-paid" />
                ) : (
                  <MdCancel className="meeting-week-badge-icon is-unpaid" />
                )}
              </span>
            </OverlayTrigger>
          );
        })}
      </div>
    );
  };

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Monthly Meeting Fees List</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        Dashboard
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li><span className="active_breadcrumb">Monthly Meeting Fees List</span></li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="card icard sticky-table-card">
          {/* <div className="card-header">
            <h5>Monthly Meeting Fees List</h5>
          </div> */}
          <div className="container-fluid f_containter">
            <div className="row mb-0">

              {hasRole([1]) &&
                <div className="mb-3 col-12 col-md-3">
                  <label className="form-label" htmlFor="country_id">
                    Country
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="country_id"
                    isClearable
                    options={countryOptions}
                    onChange={(selected) => {
                      handleStateClear();
                      applyFilter({
                        ...filter,
                        country_id: selected?.value,
                        state_id: null,
                        region_id: null,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              }

              {hasRole([1, 6]) &&
                <div className="mb-3 col-12 col-md-3">
                  <label className="form-label" htmlFor="state_id">
                    State
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    ref={selectStateRef}
                    name="state_id"
                    isClearable
                    options={stateOptions}
                    onChange={(selected) => {
                      handleRegionClear();
                      applyFilter({
                        ...filter,
                        state_id: selected?.value,
                        region_id: null,
                        chapter_id: null,
                        user_id: null,
                      });
                    }}
                  />
                </div>
              }

              {hasRole([1, 6, 7]) &&
                <div className="col-12 col-md-3">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="region_id">
                      Region
                    </label>
                    <Select
                      ref={selectRegionRef}
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      name="region_id"
                      isClearable
                      options={regionOptions}
                      onChange={(selected) => {
                        handleChapterClear();
                        applyFilter({ ...filter, region_id: selected?.value, chapter_id: null, user_id: null });
                      }}
                    />
                  </div>
                </div>
              }

              {hasRole([1, 6, 7, 2]) &&
                <div className="col-12 col-md-3">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="chapter_id">
                      Chapter
                    </label>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                      ref={selectChapterRef}
                      name="chapter_id"
                      isClearable
                      options={chapterOptions}
                      onChange={(selected) => {
                        handleMemberClear();
                        applyFilter({ ...filter, chapter_id: selected?.value, user_id: null })
                      }}
                    />
                  </div>
                </div>
              }

              <div className="col-12 col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="user_id">
                    Member
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    ref={selectMemberRef}
                    name="user_id"
                    isClearable
                    options={userOptions}
                    onChange={(selected) => applyFilter({ ...filter, user_id: selected?.value })}
                  />
                </div>
              </div>
              <div className="col-12 col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="payment_status">
                    Payment Status
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                    name="payment_status"
                    isClearable
                    options={statusOptions}
                    onChange={(selected) => applyFilter({ ...filter, payment_status: selected?.value })}
                  />
                </div>
              </div>
              <div className="col-12 col-md-3">
                <div className="mb-3 dateRangeDiv">
                  <label className="form-label" htmlFor="month_date">
                    Month Select
                  </label>
                  <div className="datepicker_wrapper">
                    <div className="datepicker">
                      <DatePicker
                        ref={datePickerRef}
                        portalId="root-portal"
                        wrapperClassName="w-100 d-block"
                        className="form-control"
                        selected={
                          filter.month_date
                            ? moment(filter.month_date, "YYYY-MM").toDate()
                            : null
                        }
                        onChange={(date) => {
                          if (date) {
                            setShowClearBtn(true);
                            applyFilter({
                              ...filter,
                              month_date: moment(date).format("YYYY-MM"),
                            });
                          } else {
                            setShowClearBtn(false);
                            applyFilter({
                              ...filter,
                              month_date: "",
                            });
                          }
                        }}
                        dateFormat="MMMM yyyy"
                        showMonthYearPicker
                        placeholderText="Select Month"
                      />
                      {showClearBtn && (
                        <button
                          className="border-0 clearDateRangeBtn"
                          data-bs-toggle="tooltip"
                          data-bs-offset="0,4"
                          data-bs-placement="top"
                          data-bs-html="true"
                          title="Clear"
                          data-bs-original-title="Clear"
                          onClick={handleDateRangeClear}
                        >
                          <i className="bx bx-x"></i>
                        </button>
                      )}
                    </div>
                    <div className="cal_icon" onClick={handleCalendarClick}>
                      <span className="input-group-text calendar-icon"></span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination paginator={paginator} page={(no) => setPage(no)} perPage={perPage} setPerPage={setPerPage} />
          )}
          <StickyTable refreshDeps={[data, loading]}>
            {/* <table className="table table-striped itable sticky-action-col"> */}
            <table className="table table-striped itable sticky-action-col">
              <thead>
                <tr>
                  <th>S.NO</th>
                  {hasRole([1]) && <th>Country</th>}
                  {hasRole([1, 6]) && <th>State</th>}
                  {hasRole([1, 6, 7]) && <th>Region</th>}
                  {hasRole([1, 6, 7, 2]) && <th>Chapter</th>}
                  <th>Member</th>
                  <th>Fee Amount</th>
                  <th style={{ textAlign: "center" }}>Meeting Weeks</th>
                  <th>Fees Month & Year</th>
                  <th style={{ textAlign: "center", width: "10%" }}>Payment Status</th>
                  <th>Paid Amount</th>
                  {/* <th>Week No</th> */}
                  {/* {hasRole([1]) &&  */}
                  <th style={{ textAlign: "center", width: "10%" }}>Action</th>
                  {/* } */}
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan="12" />
                ) :
                  data.length > 0 ? (
                    data.map((schedule, i) => (
                      <tr key={i}>
                        <td>{schedule?.sno}</td>
                        {hasRole([1]) && <td>{schedule?.country_name}</td>}
                        {hasRole([1, 6]) && <td>{schedule?.state_name || "Tamil Nadu"}</td>}
                        {hasRole([1, 6, 7]) && <td>{schedule?.region_name}</td>}
                        {hasRole([1, 6, 7, 2]) && <td>{schedule?.chapter_name}</td>}
                        <td>
                          <span className="table_img pr-2"><img src={schedule?.user_profile_image} alt="icon" /></span>{schedule?.user_name}
                        </td>
                        <td>{schedule?.fee_amount}</td>
                        <td style={{ textAlign: "center" }}>
                          {renderMeetingWeeks(schedule?.meeting_weeks)}
                        </td>
                        <td>{schedule?.fees_date}</td>
                        <td style={{ textAlign: "center" }}>
                          <Form.Check
                            type="switch"
                            id={`custom-switch-${i}`}
                            value="1"
                            disabled={!hasPermission('monthly-fees-edit')}
                            checked={schedule?.payment_status === 1 ? true : false}
                            label=""
                            onChange={(event) => {
                              const statusVal = event.target.checked ? 1 : 0;
                              const isEnable = statusVal === 1;
                              setConfirmationModal(true);
                              setConfirmation({
                                message: isEnable
                                  ? "Are you sure you want to mark all meeting fees as paid for this month?"
                                  : "Are you sure you want to mark all meeting fees as unpaid for this month?",
                                fn: () => {
                                  updatePaymentStatus(schedule?.id, statusVal);
                                },
                              });
                            }}
                          />
                        </td>
                        <td>{schedule?.paid_amount ?? "0"}</td>

                        {/* <td>{schedule?.month_no}</td> */}
                        {/* {hasRole([1]) && */}
                        <td style={{ textAlign: "center" }}>
                          <button
                            className="badge bg-label-info me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="View Meeting Fees Details"
                            data-bs-original-title="View Meeting Fees Details"
                            onClick={() => {
                              setSelectedSchedule(schedule);
                              setViewWeeksModal(true);
                            }}
                          >
                            <i className="bx bx-show"></i>
                          </button>
                        </td>
                        {/* } */}
                      </tr>
                    ))
                  ) : (
                    <NoDataFound colspan="12" message="No Data Found" />
                  )}
              </tbody>
            </table>
          </StickyTable>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination paginator={paginator} page={(no) => setPage(no)} perPage={perPage} setPerPage={setPerPage} />
          )}
        </div>
      </div>

      <Modal
        show={viewWeeksModal}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setViewWeeksModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal_title1"
          >
            Meeting Fees Details - {selectedSchedule?.user_name}
            {selectedSchedule?.fees_date && (
              <span className="datetime-section" style={{ fontSize: "14px" }}>
                ({selectedSchedule?.fees_date})
              </span>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive text-nowrap">
            <table className="table table-striped itable">
              <thead>
                <tr>
                  <th style={{ textAlign: "center", width: "7%" }}>Sl. No.</th>
                  <th style={{ textAlign: "left", width: "20%" }}>Member Name</th>
                  {/* <th style={{ textAlign: "center", width: "10%" }}>Week</th> */}
                  <th style={{ textAlign: "center", width: "18%" }}>Meeting Date & Time</th>
                  <th style={{ textAlign: "center", width: "12%" }}>Fees Amount</th>
                  <th style={{ textAlign: "center", width: "11%" }}>Payment Status</th>
                  <th style={{ textAlign: "center", width: "11%" }}>Paid at</th>
                  <th style={{ textAlign: "center", width: "11%" }}>Updated by</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {selectedSchedule?.meeting_weeks && selectedSchedule?.meeting_weeks.length > 0 ? (
                  selectedSchedule.meeting_weeks.map((week, idx) => (
                    <tr key={idx}>
                      <td style={{ textAlign: "center" }}>{idx + 1}</td>
                      <td>
                        <span className="table_img pr-2">
                          <img src={selectedSchedule?.user_profile_image} alt="icon" />
                        </span>
                        {selectedSchedule?.user_name}
                      </td>
                      {/* <td style={{ textAlign: "center" }}>Week {idx + 1}</td> */}
                      <td style={{ textAlign: "center" }}>{week.meeting_date}</td>
                      <td style={{ textAlign: "center" }}>
                        {week?.fee_amount != null && week?.fee_amount !== ""
                          ? week.fee_amount
                          : "-"}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <Form.Check
                          type="switch"
                          id={`modal-fees-switch-${idx}`}
                          disabled={!hasPermission('monthly-fees-edit')}
                          checked={week?.paid ? true : false}
                          label=""
                          onChange={(event) => {
                            const isChecked = event.target.checked;
                            const statusVal = isChecked ? 1 : 0;
                            const weeklyFeeId = week?.id;
                            const currentPaidAt = isChecked ? moment().format("DD-MM-YYYY hh:mm A") : null;

                            setConfirmationModal(true);
                            setConfirmation({
                              message: "Are you sure you want to update the payment status?",
                              fn: () => {
                                if (weeklyFeeId) {
                                  updateWeeklyPaymentStatus(weeklyFeeId, statusVal, idx, isChecked, currentPaidAt);
                                } else {
                                  setSelectedSchedule((prev) => {
                                    const updatedWeeks = [...(prev?.meeting_weeks || [])];
                                    if (updatedWeeks[idx]) {
                                      updatedWeeks[idx] = {
                                        ...updatedWeeks[idx],
                                        paid: isChecked,
                                        paid_at: currentPaidAt,
                                        updated_by_name: isChecked ? currentUpdatedByName : null,
                                      };
                                    }
                                    const allPaid = updatedWeeks.every((w) => w.paid);
                                    const anyPaid = updatedWeeks.some((w) => w.paid);
                                    const newStatus = allPaid ? 1 : anyPaid ? 2 : 0;
                                    updatePaymentStatus(prev?.id, newStatus);
                                    return {
                                      ...prev,
                                      payment_status: newStatus,
                                      meeting_weeks: updatedWeeks,
                                    };
                                  });
                                }
                              },
                            });
                          }}
                        />
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {week?.paid && week?.paid_at ? week.paid_at : "-"}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {week?.paid && (week?.updated_by_name || week?.updated_by) ? (week?.updated_by_name || week?.updated_by) : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound colspan="7" message="No Data Found" />
                )}
              </tbody>
              {selectedSchedule?.meeting_weeks && selectedSchedule?.meeting_weeks.length > 0 && (() => {
                const totalWeeks = selectedSchedule.meeting_weeks.length;
                const totalFee = Number(selectedSchedule?.fee_amount || 0);
                const weeklyFee = totalFee / totalWeeks;
                const paidWeeksCount = selectedSchedule.meeting_weeks.filter(w => w.paid).length;
                const totalPaid = weeklyFee * paidWeeksCount;
                const totalPending = totalFee - totalPaid;

                // return (
                  // <tfoot>
                  //   <tr className="fw-bold" style={{ backgroundColor: "#f8f9fa" }}>
                  //     <td colSpan="3" style={{ textAlign: "right" }}>Total:</td>
                  //     <td style={{ textAlign: "center" }}>
                  //       <div>Total: ₹{totalFee.toFixed(2)}</div>
                  //       <div className="text-success" style={{ fontSize: "12px" }}>Paid: ₹{totalPaid.toFixed(2)}</div>
                  //       {totalPending > 0 && (
                  //         <div className="text-danger" style={{ fontSize: "12px" }}>Pending: ₹{totalPending.toFixed(2)}</div>
                  //       )}
                  //     </td>
                  //     <td style={{ textAlign: "center" }}>
                  //       <span className={`badge bg-label-${paidWeeksCount === totalWeeks ? 'success' : paidWeeksCount > 0 ? 'warning' : 'danger'}`}>
                  //         {paidWeeksCount} / {totalWeeks} Paid
                  //       </span>
                  //     </td>
                  //   </tr>
                  // </tfoot>
                // );
              })()}
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-primary ibutton"
            onClick={() => setViewWeeksModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={confirmationModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setConfirmationModal(false)}
        backdrop="static"
        className="confirmation-modal"
        backdropClassName="confirmation-backdrop"
      >
        <Modal.Header closeButton className="no-border"></Modal.Header>
        <Modal.Body className="idel_popup">
          <div className="icon_holder">
            <div className="pop_del_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#1A4331"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </div>
          </div>
          <h6 className="text-center modal_title">{confirmation?.message}</h6>
          <div className="text-center">
            <button
              onClick={() => {
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-danger btn-sm me-2 iclose_btn"
            >
              No
            </button>
            <button
              onClick={() => {
                confirmation.fn();
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-success btn-sm isubmit_button"
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MonthlyFeesList;
